import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index.js';

import axios from 'axios';
import api, { initializeMaintenanceService } from './services/axiosConfig';
import { initializeCacheInterceptor } from './services/cacheInterceptor';

Object.keys(api).forEach((key) => {
    axios[key] = api[key];
});

axios.interceptors = api.interceptors;
import PortalVue from 'portal-vue';
import FloatingVue from 'floating-vue';

let Sentry = null;
import VTooltip from 'v-tooltip';
import windowResizeMixin from './lib/window-resize';

Vue.use(VTooltip);

Vue.use(PortalVue);

window.setupVCalendar = () => {
    return import('v-calendar').then((VCalendar) => {
        Vue.use(VCalendar.default, {
            componentPrefix: 'v',
            locales: {
                de: {
                    firstDayOfWeek: 1,
                    masks: {
                        L: 'DD.MM.YYYY',
                        title: 'MMMM YYYY',
                        weekdays: 'W',
                    },
                    dayNames: [
                        'Sonntag',
                        'Montag',
                        'Dienstag',
                        'Mittwoch',
                        'Donnerstag',
                        'Freitag',
                        'Samstag',
                    ],
                    dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                    monthNames: [
                        'Januar',
                        'Februar',
                        'März',
                        'April',
                        'Mai',
                        'Juni',
                        'Juli',
                        'August',
                        'September',
                        'Oktober',
                        'November',
                        'Dezember',
                    ],
                    monthNamesShort: [
                        'Jan',
                        'Feb',
                        'Mär',
                        'Apr',
                        'Mai',
                        'Jun',
                        'Jul',
                        'Aug',
                        'Sep',
                        'Okt',
                        'Nov',
                        'Dez',
                    ],
                },
            },
        });
    });
};
Vue.config.productionTip = false;

Vue.use(FloatingVue);

initializeMaintenanceService();
initializeCacheInterceptor(store, api);

window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    const pattern =
        /Loading chunk (\d)+ failed|Loading CSS chunk (\d)+ failed|Failed to fetch dynamically imported module|Importing a module script failed|ChunkLoadError/i;
    const isChunkLoadError =
        error && ((error.message && pattern.test(error.message)) || pattern.test(error.toString()));

    if (isChunkLoadError) {
        event.preventDefault();
        const currentPath = window.location.pathname + window.location.search;
        sessionStorage.setItem('pendingReloadPath', currentPath);
        window.location.reload();
    }
});

const app = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');

if (import.meta.env.PROD) {
    const initSentry = () =>
        import('@sentry/vue').then((module) => {
            Sentry = module;
            const sentryIntegrations = [
                new Sentry.BrowserTracing({
                    routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                }),
            ];
            if (Math.random() < 0.05) {
                sentryIntegrations.push(new Sentry.Replay());
            }
            Sentry.init({
                Vue,
                dsn: import.meta.env.VITE_SENTRY_DSN,
                integrations: sentryIntegrations,
                tracesSampleRate: 0.1,
                tracePropagationTargets: ['localhost', /^https:\/\/taxifusion\.de/],
                replaysSessionSampleRate: 0.05,
                replaysOnErrorSampleRate: 1.0,
            });
        });

    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => initSentry());
    } else {
        setTimeout(() => initSentry(), 0);
    }
}

const initToasted = () =>
    import('vue-toasted').then((module) => {
        const toasted = module.default || module;
        Vue.use(toasted, {
            position: window.innerWidth > 768 ? 'bottom-left' : 'top-left',
            duration: 5000,
        });
    });

if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => initToasted());
} else {
    window.addEventListener('load', () => initToasted());
}
